import C from "../actionTypes";
import settings from "../../config/settings";

export const profileDetailsData = (state = {}, action) => {
    switch (action.type) {
        case C.PROFILE_DETAILS_SUCCESS:
            return action.profileDetailsData
        case C.PROFILE_DETAILS_UPDATE_SUCCESS:
            return {
                account: state.account,
                success: action.profileDetailsData.success
            }
        case C.PROFILE_DETAILS_FAILURE:
            return {
                account: state.account,
                success: action.profileDetailsData.success
            }
        case C.USER_LOGOUT:
            return {}
        default:
            return state
    }
};

export const changedPasswordData = (state = {}, action) => {
    switch (action.type) {
        case C.CHANGE_PASSWORD_REQUEST:
            return state
        case C.CHANGE_PASSWORD_SUCCESS:
            return action.changePasswordMessage || state
        case C.CHANGE_PASSWORD_FAILURE:
            return  action.changePasswordFail
        case C.CLOSE_FORM:
            return { ...state, changePasswordFail: ''}
        case C.CHANGE_PASSWORD_DEFAULT:
            return {}
        default:
            return state
    }
};

export const changeEmailData = (state = {}, action) => {
    switch (action.type) {
        case C.CHANGE_EMAIL_SUCCESS:
            return action.changeEmailData
        case C.CHANGE_EMAIL_FAILURE:
            return action.changeEmailData
        case C.CHANGE_EMAIL_DEFAULT:
            return {}
        default:
            return state
    }
};

export const forgotPasswordData = (state = {}, action) => {
    switch (action.type) {
        case C.FORGOT_PASSWORD_SUCCESS:
            return action.forgotPasswordData
        case C.FORGOT_PASSWORD_FAILURE:
            return action.forgotPasswordData
        case C.USER_LOGOUT:
            return {}
        default:
            return state
    }
};

export const soundEnabled = (state = true, action) => {
    switch (action.type) {
        case C.SOUND_TOGGLE:
            return !state
        default:
            return state
    }
};

// export const changedAccountsData = (state = {}, action) => {
//     switch (action.type) {
//         case C.REFRESH_ACCOUNTS_DATA_SUCCESS:
//             return {...state, refreshed: action.changedAccountsData};
//         case C.ADD_ACCOUNTS_DATA:
//             return {...state, added: action.newAccountsData};
//         case C.REMOVE_ACCOUNTS_DATA:
//             return {...state, removed: action.removedAccountsData};
//         case C.REFRESH_ACCOUNTS_DATA_FAILURE:
//             return {...state};
//         case C.USER_LOGOUT:
//             return {};
//         default :
//             return state
//     }
// };

const initialLanguageState = localStorage.language || settings.languages[0];
export const selectedLanguage = (state = initialLanguageState, action) => {
    switch (action.type) {
        case C.LANGUAGE_CHANGE:
            return action.value;
        default :
            return state
    }
};

export const selectedGlobalAvatar = (state = 0, action) => {
    switch (action.type) {
        case C.CHANGE_PROFILE_AVATAR_REQUEST:
            return action.value;
        case C.CHANGE_PROFILE_AVATAR_SUCCESS:
            return action.value;
        case C.CHANGE_PROFILE_AVATAR_FAILURE:
            return state;
        default :
            return state
    }
};
